/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPLOAD_FILE } from "../graphql";

export const getUploadClient = () => {
  const app = VApplication.getInstance();
  const graphqlModule = app.getSync(
    "services.GraphqlServerModule",
  ) as GraphqlServerModule;

  return graphqlModule?.getClient?.("graphql-gateway");
};

export const isValidHttpUrl = (str: string) => {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
  return urlRegex.test(str);
};

export const getFileTypeFromBase64 = (base64String: string) => {
  const matches = base64String.match(/^data:image\/(\w+)/);

  if (matches && matches.length === 2) {
    return matches[1];
  }

  return null;
};

export const uploadFile = async (
  arr: any[] = [],
  name: string,
  category1 = "costumeattributes",
) => {
  const client = getUploadClient();
  const imagesUrlArray: string[] = [];

  if (!client) {
    return imagesUrlArray;
  }

  if (!Array.isArray(arr) || arr.length === 0) {
    return imagesUrlArray;
  }

  for (const obj of arr) {
    if (!obj) continue;

    const dataString = typeof obj === "string" ? obj : obj?.base64;

    if (!dataString) continue;

    if (typeof dataString === "string" && isValidHttpUrl(dataString)) {
      imagesUrlArray.push(dataString);
      continue;
    }

    const fileType =
      typeof dataString === "string"
        ? getFileTypeFromBase64(dataString) ?? "jpeg"
        : "jpeg";

    try {
      const res = await client.mutate({
        mutation: UPLOAD_FILE,
        variables: {
          name: fileType,
          data: dataString,
          category1,
          category2: name ?? "costumeImg",
          addBandName: true,
        },
        fetchPolicy: "no-cache",
      });

      if (res?.data?.uploadFile) {
        imagesUrlArray.push(res.data.uploadFile);
      }
    } catch (err: any) {
      console.error("Error uploading file:", err);
    }
  }

  return imagesUrlArray;
};

export const handleUploadError = (err: any) => {
  const displayMessage =
    err?.graphQLErrors &&
    Array.isArray(err?.graphQLErrors) &&
    err?.graphQLErrors.find((item: any) => item.extensions);

  if (displayMessage?.extensions?.display_message) {
    return displayMessage.extensions.display_message;
  }

  return err?.message ?? err;
};
